import {
  types,
  ICreateDataChartAction,
  ICreateDataChartSuccessAction,
  ICreateDataChartFailureAction,
  ICreateDataChartPollingSuccessAction,
  ICreateDataChartPollingFailureAction,
  ICreateDataChartShowProgressAction,
  ICreateDataChartHideProgressAction,
} from '../types/datachart'
import { IPollingTaskData } from '../types/polling'

export const createDataChart = (
  groupId: string,
  title: string,
  dataStreamURI: string
): ICreateDataChartAction => ({
  type: types.CREATE_DATACHART__STARTED,
  groupId,
  title,
  dataStreamURI,
})

export const createDataChartSuccess = (
  message: string
): ICreateDataChartSuccessAction => ({
  type: types.CREATE_DATACHART__SUCCESS,
  message,
})

export const createDataChartFailure = (
  message: string,
  correlationId: string
): ICreateDataChartFailureAction => ({
  type: types.CREATE_DATACHART__FAILURE,
  message,
  correlationId,
})

export const createDataChartPollingSuccess = (
  data: IPollingTaskData
): ICreateDataChartPollingSuccessAction => ({
  type: types.CREATE_DATACHART_POLLING__SUCCESS,
  data,
})

export const createDataChartPollingFailure = (
  message: string,
  correlationId: string
): ICreateDataChartPollingFailureAction => ({
  type: types.CREATE_DATACHART_POLLING__FAILURE,
  message,
  correlationId,
})

export const createDataChartShowProgress = (): ICreateDataChartShowProgressAction => ({
  type: types.CREATE_DATACHART_SHOW_PROGRESS,
})

export const createDataChartHideProgress = (): ICreateDataChartHideProgressAction => ({
  type: types.CREATE_DATACHART_HIDE_PROGRESS,
})
